<template>
  <headerMenu :title='route.query.title' :type='route.query.type'/>
  <router-view />
  <!-- <recharge v-if='route.query.title === "会员充值"' />
  <bill v-if='route.query.title === "账单明细"'/>
  <paintings v-if='route.query.title === "私人画夹"' />
  <invite v-if="inviteStore.inviteShow"/> -->
</template>

<script setup>
import { ref, reactive, toRefs, onBeforeMount, onMounted, watchEffect, computed } from 'vue';
import { useCounterStore } from '@/store';
import { useInviteStore } from '@/store/invite'
import { useRoute, useRouter } from 'vue-router';
import headerMenu from '@/components/headerMenu.vue'
import paintings from './paintings.vue'
import recharge from './recharge.vue'
import bill from './bill.vue'
import invite from "./invite/invite.vue"
/**
* 仓库
*/
const store = useCounterStore();
const inviteStore = useInviteStore()
/**
* 路由对象
*/
const route = useRoute();
/**
* 路由实例
*/
const router = useRouter();
//console.log('1-开始创建组件-setup')
/**
* 数据部分
*/
const data = reactive({})
onBeforeMount(() => {
  //console.log('2.组件挂载页面之前执行----onBeforeMount')
})
onMounted(() => {
  //console.log('3.-组件挂载到页面之后执行-------onMounted')
})
watchEffect(()=>{
  // console.log(route);
  // route.meta.title = route.query.title
})
// 使用toRefs解构
// let { } = { ...toRefs(data) } 
defineExpose({
  ...toRefs(data)
})

</script>
<style lang='scss' scoped>
</style>